export const SCORE_STORAGE_KEY = 'SCORE_STORAGE_KEY'